<template>
    <div>
        <div class="d-flex justify-content-end my-2">
            <b-button
                    v-b-modal.createMaterialGroup
                    size="sm"
                    variant="success"
                    v-if="$can('create', 'materialGroups')"
            >
                Создать группу материалов
            </b-button>
        </div>
        <b-row class="my-2 align-items-center">
            <b-col cols="12" md="6" class="mb-2 mb-md-0">
                <b-input-group size="sm">
                    <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Введите для поиска"
                    ></b-form-input>
                </b-input-group>
            </b-col>
            <b-col cols="12" md="6">
                <div class="d-flex flex-wrap justify-content-md-end align-items-center">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0 mb-2 mb-md-0 mr-2"
                    ></b-pagination>
                    <div class="mb-2 mb-md-0">
                        <b-form-group
                                label="На странице"
                                label-cols="6"
                                label-size="sm"
                                label-for="perPageSelect"
                                class="mb-0 d-flex align-items-center"
                        >
                            <b-form-select
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-table
                responsive="sm"
                :fields="fields"
                :filter="filter"
                small
                striped
                :items="items"
                :current-page="currentPage"
                :per-page="perPage"
                @filtered="onFiltered"
                sticky-header="80vh"
        >
            <template v-slot:cell(actions)="data">
                <i class="fas fa-pen text-center text-success mx-2"
                   @click="onEdit(data.item)"
                   v-if="$can('update', 'materialGroups')"
                ></i>
                <i class="fas fa-trash-alt text-danger text-center mx-2"
                   @click="onDelete(data.item)"
                   v-if="$can('delete', 'materialGroups')"
                ></i>
            </template>
        </b-table>
        <create-material-group></create-material-group>
        <delete-material-group></delete-material-group>
        <edit-material-group></edit-material-group>
    </div>
</template>

<script>
    import CreateMaterialGroup from "./CreateMaterialGroup/CreateMaterialGroup.vue";
    import DeleteMaterialGroup from "./DeleteMaterialGroup/DeleteMaterialGroup.vue";
    import EditMaterialGroup from "./EditMaterialGroup/EditMaterialGroup.vue";

    export default {
        components: {
            CreateMaterialGroup,
            DeleteMaterialGroup,
            EditMaterialGroup
        },
        computed: {
            items() {
                return this.$store.state.materials.groups;
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: `name`,
                        label: `Имя группы материалов`,
                        sortable: true
                    },
                    {
                        label: ``,
                        key: `actions`,
                        class: `w-80px`
                    }
                ],
                filter: null,
                filterOn: [],
                perPage: 200,
                pageOptions: [5, 10, 15, 20, 100, 200],
                totalRows: 1,
                currentPage: 1,
                value: null
            }
        },
        async mounted() {
            await this.$store.dispatch(`getMaterialGroups`);
            this.totalRows = this.items.length;
        },
        methods: {
            onDelete({id}) {
                this.$store.commit(`setSelectedMaterialGroupId`, id);
                this.$bvModal.show(`deleteMaterialGroup`);
            },
            onEdit({id}) {
                this.$store.commit(`setSelectedMaterialGroupId`, id);
                this.$bvModal.show(`editMaterialGroup`);
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            }
        },
        name: "MaterialGroups"
    }
</script>

<style scoped>

</style>